import { Attributes, DateUtils, Misc, Model, Rules, Validation } from '@singularsystems/neo-core';

export default class SpareCapacityCriteria extends Model.CriteriaBase {
    static typeName = "SpareCapacityCriteria";

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = DateUtils.today();

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<SpareCapacityCriteria>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Spare Capacity Criteria";
    }
}